import React from 'react';
import { CookiesProvider } from 'react-cookie';
// Import User Provider
import UserProvider from 'engine/Contexts/User.context';
import { ThemeContextProvider } from 'engine/Contexts/Theme.context';
import AppAntdTranslationProvider from 'engine/Contexts/AppAntdTranslationProvider';

// Import i18n translations
import { I18nextProvider, initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import i18nextOptions from 'engine/i18nextOptions';

i18n.use(LanguageDetector).use(initReactI18next).init(i18nextOptions);

function AppProviders({ children }) {
  return (
    <CookiesProvider>
      <I18nextProvider i18n={i18n}> 
        <AppAntdTranslationProvider>
          <UserProvider>
            <ThemeContextProvider>
              {children}
            </ThemeContextProvider>
          </UserProvider>
        </AppAntdTranslationProvider>
      </I18nextProvider> 
    </CookiesProvider>
  );
}

export { AppProviders, i18n };
export default AppProviders;